export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '2.6.1'
};
